import { ThemeProvider as MUIThemeProvider } from "@mui/material";

import { useInfo } from "../InfoProvider/InfoProvider";
import theme, { ThemeType } from "./theme";

interface Props {
  children: React.ReactNode;
}

const ThemeProvider: React.FC<Props> = ({ children }) => {
  const { theme: themeMode } = useInfo();

  return <MUIThemeProvider theme={theme(themeMode.mode as ThemeType)}>{children}</MUIThemeProvider>;
};

export default ThemeProvider;
